import { render } from "./index.vue?vue&type=template&id=0e613424&scoped=true&bindings={}"
import script from "./library-info.js?vue&type=script&lang=js"
export * from "./library-info.js?vue&type=script&lang=js"

import "./library-info.scss?vue&type=style&index=0&id=0e613424&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e613424"

export default script